import { Api } from '../api';
import { files } from '../endpoints';
import type { FileEntity, FileItem, FileTypeEntity, UploadFileResponse } from './models';

export class FileApi extends Api {
  static getFileTypes = (signal?: AbortSignal) => this.get<FileTypeEntity[]>(files.getTypes(), { signal });

  static getApplicationFiles = (applicationId: string, signal?: AbortSignal) =>
    this.get<FileEntity[]>(files.getApplicationFiles(applicationId), { signal });

  static downloadFile = (fileId: string, signal?: AbortSignal) => this.get<Blob>(files.downloadFile(fileId), { responseType: 'blob', signal });

  static deleteFile = (fileId: string, signal?: AbortSignal) => this.delete<''>(files.deleteFile(fileId), { responseType: 'none', signal });

  static uploadFile = (searchParams: FileItem[], manualApplicationId?: string) => {
    const formData = searchParams.reduce((acc, file) => {
      acc.append('files', file);
      acc.append('documentTypes', file.fileType);
      return acc;
    }, new FormData());
    if (manualApplicationId) formData.append('manualApplicationId', manualApplicationId);

    return this.post<UploadFileResponse[]>(files.uploadFile(), formData);
  };

  static uploadFiles = (searchParams: FileItem[], selectedApplicationId: string) => {
    const formData = searchParams.reduce((acc, file) => {
      acc.append('files', file);
      acc.append('documentTypes', file.fileType);
      if (file.country) acc.append('country', file.country);
      if (file.expiryDate) acc.append('expireDate', file.expiryDate);
      if (file.citizenByInvestment !== undefined) acc.append('citizenshipBytInvestment', file.citizenByInvestment ? 'true' : 'false');
      if (file.number) acc.append('number', file.number);
      return acc;
    }, new FormData());
    formData.append('selectedApplicationId', selectedApplicationId);

    return this.post<UploadFileResponse[]>(files.uploadFile(), formData);
  };
}
